/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { SafeString } from "@ember/template/-private/handlebars";
import Component from "@glimmer/component";
import { BufferedChangeset } from "ember-changeset/types";
import IntlService from "ember-intl/services/intl";
import { bioExamPrescriptionContentFromParams } from "../../utils/prescription-helpers";
import styles from "./index.module.css";
let BioExamPrescriptionPreviewFormComponent = (_class = class BioExamPrescriptionPreviewFormComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
  }
  get prescriptionAldContent() {
    const validityPeriod = parseInt(this.args.changeset.get("validityPeriod"));
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + validityPeriod);
    return htmlSafe(bioExamPrescriptionContentFromParams(this.args.changeset.get("occurredAt"), endDate, this.args.changeset.get("exams"), this.args.changeset.get("frequency"), this.args.changeset.get("customOrders"), this.args.changeset.get("aldRelatedComments"), this.intl, this.store).replace(/\n/gm, "<br />"));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BioExamPrescriptionPreviewFormComponent as default };